var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSortDown48Line = function SvgIconSortDown48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 26.839h-9.6c-1.16 0-2.21.69-2.66 1.75-.46 1.07-.24 2.3.56 3.14l4.8 5.06c.55.58 1.31.9 2.1.9s1.56-.33 2.1-.9l4.8-5.06c.8-.84 1.02-2.08.56-3.14a2.883 2.883 0 0 0-2.66-1.75ZM19.2 21.159h9.6c1.16 0 2.21-.69 2.66-1.75.46-1.07.24-2.3-.56-3.14l-4.8-5.06c-.54-.58-1.31-.91-2.1-.91s-1.56.33-2.1.9l-4.8 5.06c-.8.84-1.02 2.08-.56 3.14.46 1.07 1.5 1.75 2.66 1.75v.01Zm4.8-7.23 3.63 3.83h-7.27l3.63-3.83H24Z",
    fill: "current"
  })));
};
export default SvgIconSortDown48Line;